var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFacebookFooter = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.821 0.485352H3.18173C1.42124 0.485352 0 1.97464 0 3.81653V37.1556C0 38.9932 1.42124 40.4854 3.18173 40.4854H36.821C38.5705 40.4854 40 38.9932 40 37.1556V3.81653C40 1.97464 38.5705 0.485352 36.821 0.485352ZM26.8874 12.3609C26.0598 11.8535 25.4046 11.4536 24.5811 11.4536C23.774 11.4536 23.0819 11.6643 22.729 12.0212C22.3788 12.3738 22.2023 13.0576 22.2023 14.0681V15.5602H26.5167L25.5837 19.7156H22.2009V33.5234H16.7827V19.7156H14.2521V15.5602H16.7827V13.9735C16.7827 12.305 16.9728 11.306 17.349 10.4789C17.7252 9.65757 18.4556 8.74307 19.4679 8.22562C20.4774 7.70817 21.9739 7.4473 23.5237 7.4473C25.1105 7.4473 26.3498 8.00201 27.8709 8.44923L26.8874 12.3609Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebookFooter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook-footer.2ceff116.svg";
export { ForwardRef as ReactComponent };